import React from 'react';
import PropTypes, { any } from 'prop-types';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Img from '../../../../../components/Img';

import styles from './regConfirmation.scss';
import CampRegistrationSuccessCard from '../../../../../components/EventRegForm/CampRegistrationSuccessCard';

const MultiRegConfirmation = (props) => {
    const { isWebView, multipleDivisionRegistrations, succesfulMultiDivisionRegistration } = props;
    const { event = { invites: [] } } = useSelector(({ eventProfile }) => eventProfile);

    const organizerEmail = event.data?.email;
    const organizerPhone = event.data?.phone;

    return event.data ? (
        <div className={styles.regConfirmationPage}>
            <div className="row">
                <div className="col-md-8">
                    <h4 className="d-flex d-md-none mt48 aic text-semi"><Img src="/img/v2/icons/icon-valid-grad.svg" className="h48 mr16" /> {`You're registered!`}</h4>
                    <h5 className="d-none d-md-flex mt48 aic"><Img src="/img/v2/icons/icon-valid-grad.svg" className="h48 mr16" /> {`You're registered!`}</h5>
                    {succesfulMultiDivisionRegistration && (
                        <div className="text-black">
                            Registrations may take time to appear on the player list if you are registering multiple players.
                        </div>
                    )}
                    <div className={styles.divisionList}>
                        {succesfulMultiDivisionRegistration &&
                            event?.data?.eventDivisions
                                .filter((division) => multipleDivisionRegistrations[division.id]?.quantity > 0) // Filter divisions that were selected in the previous process
                                .map((division) => (
                                    <CampRegistrationSuccessCard
                                        key={division.id}
                                        division={division}
                                        event={event.data}
                                        currentRegistration={multipleDivisionRegistrations[division.id] || {}}
                                    />
                                ))}
                    </div>
                    <div className={`${styles.text} mt8`}>For any questions please contact the event provider at {!!organizerEmail && <><a href={`mailto:${organizerEmail}`}>{organizerEmail}</a> or </>}{organizerPhone}.</div>

                    <div className="mt24 mb24">
                        <div className="d-inline mt24 link clickable" onClick={props.backToEvent}>View the event</div>
                        {!isWebView && <>&nbsp;|&nbsp;<Link className="d-inline mt24" to={`/home`}>Return to home dashboard</Link></>}
                    </div>
                </div>

            </div>
        </div>
    ) : null;
};

MultiRegConfirmation.propTypes = {
	backToEvent: PropTypes.func.isRequired,
	isWebView: PropTypes.bool,
    succesfulMultiDivisionRegistration: PropTypes.bool.isRequired,
    multipleDivisionRegistrations: PropTypes.objectOf(any).isRequired,
};

MultiRegConfirmation.defaultProps = {
    isWebView: false,
};

export default MultiRegConfirmation;
